<template>
    <div style="width: 100%; height: 100px;">
        <b-loading :is-full-page="loader.isFullPage" :active.sync="loader.isLoading" :can-cancel="false"></b-loading>
        <div style="border: 1px solid #e9e9e9; padding: 11px; min-height: 220px;" >
            <div v-if="priceCheckError == false">
                <p><b>Products price:</b> {{priceCheckData.subtotals.items | currency}} EUR</p>
                <p><b>Fee:</b> {{priceCheckData.subtotals.fee | currency}} EUR</p>

                <div v-for="shipment in priceCheckData.shipments">
                    <hr>
                    <p>
                        <b>Shipping methods for products:</b>
                        <span v-for="(item, index) in shipment.items">
                            {{getProductName(item.reference)}}<span v-if="index < shipment.items.length - 1">, </span>
                        </span>
                    </p>

                    <p v-for="quote in shipment.quotes">
                        {{quote.service}} ({{quote.shipping_option}}) - {{quote.price | currency}} {{quote.currency}}
                    </p>
                </div>
            </div>
            <div v-else>
                {{priceCheckErrorMessage}}
            </div>
            <br>
            <template v-if="!loader.isLoading">
                <section>
                    <div class="buttons">
                        <b-button size="is-small" v-on:click="priceCheck()">Update</b-button>
                    </div>
                </section>
            </template>
        </div>
    </div>
</template>

<script>
    import LayoutBasic from '@/layouts/LayoutBasic'

    export default {
        name: 'price_check',
        components: {
            LayoutBasic
        },

        data() {
            return {
                purchaseOrderId: null,
                priceCheckData: {},
                priceCheckError: true,
                priceCheckErrorMessage: '',
                orderProducts: {},
                loader: {
                    isFullPage: true,
                    isLoading: true,
                },
            };
        },

        methods: {
          getOrderProducts() {
            let thisScope = this;
            const funcName = "cloudprintercom__getorderproducts";
            const reqData ={
              "arguments": JSON.stringify({
                "orderId" : this.purchaseOrderId
              })
            };

            ZOHO.CRM.FUNCTIONS.execute(funcName, reqData)
              .then(function(data){
                thisScope.orderProducts = JSON.parse('[' + data.details.output + ']');
              })
          },

          getProductName(id) {
            for (let index in this.orderProducts) {

              if (this.orderProducts[index].id == id) {
                return this.orderProducts[index].name;
              }
            }

            return id;
          },

          priceCheck() {
            this.loader.isLoading = true;
            let thisScope = this;
            const funcName = "cloudprintercom__pricecheck";
            const reqData = {
              "arguments": JSON.stringify({
                "orderId" : this.purchaseOrderId
              })
            };

            ZOHO.CRM.FUNCTIONS.execute(funcName, reqData)
              .then(function(data){
                const responseData = JSON.parse(data.details.output);

                if (responseData.success == true) {
                  thisScope.priceCheckError = false;
                  thisScope.priceCheckData = JSON.parse(responseData.response);
                } else {
                  thisScope.priceCheckError = true;
                  thisScope.priceCheckErrorMessage = responseData.message;
                }
              })
              .finally(() => {
                  thisScope.loader.isLoading = false;
              })
          },
        },

        created() {
            this.loader.isLoading = true;
            ZOHO.embeddedApp.on("PageLoad", (data) => {
                this.purchaseOrderId = data.EntityId;
                this.priceCheck();
                this.getOrderProducts();
            });
            ZOHO.embeddedApp.init()
        }
    }
</script>
